<template>
	<v-dialog
		class="dialog"
		v-model="visible"
		:max-width="maxWidth"
		persistent
	>
		<v-alert
			border="top"
			colored-border
			:color="'warning'"
		>
			<div class="title-text">{{ title_text }}</div>
			<div class="content-text my-1">{{ content_text }}</div>
			<v-text-field
				v-model="edit_name"
				:color="color"
				background-color="#FFFFFF"
				outlined
				dense
				hide-details
			></v-text-field>
			<div v-if="isDynamic" class="switch-detail mb-4">
				<v-switch
					v-model="is_dynamic"
					class="mr-2"
					:color="color"
					inset
					dense
					label="Dynamic search" />
				<v-tooltip attach right max-width="calc(55%)" z-index="11">
					<template v-slot:activator="{ on, attrs }">
						<div v-bind="attrs" v-on="on" class="mt-2">
							<InfoOutline width="20" height="20" :color="`rgba(25, 42, 62, 0.5)`"/>
						</div>
					</template>
					<span>Dynamic searches are always updated. Search results are based on the current database.</span>
					<br/>
					<span>Non-dynamic searches save only search results found at the time the worklist is created.</span>
				</v-tooltip>
			</div>
			<div class="button mt-4">
				<v-btn outlined color="rgba(25, 42, 62, 0.7)" class="text-capitalize" @click="$emit('cancel')">{{ cancel_button }}</v-btn>
				<v-btn depressed :disabled="edit_name.length === 0" :color="'#00AAFD'" class="ml-2 white--text text-capitalize" @click="onConfirm()">
					<component
						v-if="icon" 
						:is="icon.name"
						:color="icon.color" 
						:width="icon.width" 
						:height="icon.height"
					/>
					{{ confirm_button }}
				</v-btn>
			</div>
		</v-alert>
	</v-dialog>
</template>
<script>
import InfoOutline from "@/components/icons/info_outline";


export default {
	name: 'TaskSaveAsDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		title_text: {
			type: String,
			default: ''
		},
		content_text: {
			type: String,
			default: ''
		},
		confirm_button: {
			type: String,
			default: 'Confirm'
		},
		cancel_button: {
			type: String,
			default: 'Cancel'
		},
		icon: {
			type: Object,
			default: null
		},
		maxWidth: {
			type: Number,
			default: 500
		},
		color: {
			type: String,
			default: '',
		},
		isDynamic: {
			type: Boolean,
			default: false
		}
	},
	components: {
		InfoOutline
	},
	data() {
		return {
			edit_name: '',
			is_dynamic: true,
		}
	},
	methods: {
		onConfirm() {
			if (this.isDynamic) {
				const param = {
					name: this.edit_name,
					dynamic: this.is_dynamic,
				};
				this.$emit('ok', param);
			} else {
				this.$emit('ok', this.edit_name);
			}
			
		}
	}
}
</script>
<style lang="scss" scoped>
.dialog {
	padding: 20px;
}
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #192A3E;
}
.content-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #37495F;
}
.switch-detail {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
}
.button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.v-alert {
	margin-bottom: 0;
}
.theme--light.v-btn.v-btn--disabled {
  color: #FFFFFF !important;
}
</style>